<template>
  <svg
    v-if="icon"
    :class="'pkc-icon_' + icon"
    :width="width"
    :height="height"
  >
    <use :xlink:href="icon" />
  </svg>
</template>

<script>
export default {
  name: 'PkcIcon',
  props: {
    icon: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 50
    },
    height: {
      type: [Number, String],
      default: 50
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/data-center/components/pkc-icon.vue"
}
</vue-filename-injector>
